import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import React, { useState } from "react";
import TablePaginationActions from "./tablePaginationActions";
import Row from "./tableRowMobile";
const columns = [
  {
    id: "transactionDate",
    label: "Transaction Date",
  },
  { id: "accountNumber", label: "Account #" },
  {
    id: "amount",
    label: "Amount",
    align: "right",
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 500,
  },
}));

export default function CustomTableMobile(props) {
  const {
    pagedItems = [],
    totalItems = 10,
    handleFetch,
    pageIndex,
    handleQueryUpdate,
    query,
  } = props;
  const classes = useStyles();

  const [pageSize, setPageSize] = useState(10);
  const [pageIndexLocal, setPageIndex] = useState(pageIndex - 1);

  const handleChangePage = (event, newPage) => {
    setPageIndex(newPage);
    handleQueryUpdate({ ...query, pageNumber: ++newPage, pageSize });
    handleFetch();
  };

  const handleChangeRowsPerPage = (e) => {
    const pageSize = e.target.value;
    setPageSize(pageSize);
    handleQueryUpdate({ ...query, pageSize });
    handleFetch();
  };

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" className={classes.root}>
          <TableHead>
            <TableRow>
              <TableCell />

              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {pagedItems.map((row, index) => {
              return <Row row={row} key={index} />;
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 20, 30, 40, 50]}
        component="div"
        count={totalItems}
        rowsPerPage={pageSize}
        page={pageIndexLocal}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
      />
    </Paper>
  );
}
